// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'relative',
    },
    content: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'scroll',
      overflowY: 'hidden',
      marginRight: 10,
    },
    hiddenScrollbar: {
      '&::-webkit-scrollbar': {
        height: '0px !important',
        width: '0px !important',
      },
    },
    visibleScrollbar: {
      paddingBottom: 10,
      '&::-webkit-scrollbar': {
        height: '10px !important',
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: 10,
        boxShadow: 'inset 0 0 5px #ccc',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 10,
        background: theme.palette.primary.main,
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.palette.primary.dark,
      },
    },
  }),
);

export default useStyles;
